<template>
  <div id="Choos">
    <div class="title">{{ $t("choos.txt1") }}</div>
    <div class="system">
      <div :class="system == 1 ? 'mr' : ''" @click="getlist(1)">
        <!-- <img src="@/assets/img/a.png"> -->
        <i class="u-iconfont uicon-android-fill system_logo"></i>
        {{ $t("choos.android") }}
      </div>
      <div :class="system == 2 ? 'mr' : ''" @click="getlist(2)">
        <i class="u-iconfont uicon-apple-fill system_logo"></i>
        {{ $t("choos.ios") }}
      </div>
    </div>
    <div class="system_ul" :style="{ width: list.length > 2 ? '1110px' : '750px' }">
      <div @click="oks(val, key)" :class="isshow == key ? 'system_li mr' : 'system_li'" v-for="(val, key) in list"
        :key="key">
        <div class="top">
          <div class="top_left">
            <div class="top_l_t">{{ val.name }}</div>
            <div class="top_l_b">
              {{ $t("choos.monitor") }} {{ val.equipment }}
              {{ val.equipment > 1 ? $t("choos.devices") : $t("choos.device") }}
            </div>
          </div>
          <div class="top_right">
            <b><span style="
                  font-size: 15px;
                  font-family: Noto Sans;
                  margin-right: 3px;
                ">$</span>{{
                  val.package_prices.find((item) => item.id === ida)
                    ? val.package_prices.find((item) => item.id === ida)
                      .price_per_month
                    : val.name === "Premium"
                      ? val.package_prices[2].price_per_month
                      : val.package_prices[0].price_per_month
                }}</b>
            <div>
              <s>${{
                val.package_prices.find((item) => item.id === ida)
                  ? val.package_prices.find((item) => item.id === ida)
                    .del_price_month
                  : val.name === "Premium"
                    ? val.package_prices[2].del_price_month
                    : val.package_prices[0].del_price_month
              }}</s>
              <span>/{{ $t("choos.month") }}</span>
            </div>
          </div>
        </div>
        <div class="option">
          <div class="option_o" @click="optionOk(val1.id, val, key)" v-for="(val1, key1) in val.package_prices"
            :key="key1" style="display: flex">
            <div style="width: 170px">
              <template v-if="isshow === key">
                <img v-if="ida == val1.id" src="@/assets/img/qdui.png" />
                <img v-else src="@/assets/img/qnodui.png" />
              </template>
              <template v-if="isshow !== key && key !== 0">
                <img v-if="key1 === 0" src="@/assets/img/qdui.png" />
                <img v-else src="@/assets/img/qnodui.png" />
              </template>
              <template v-if="isshow !== key && key === 0">
                <img v-if="key1 === 0" src="@/assets/img/qdui.png" />
                <img v-else src="@/assets/img/qnodui.png" />
              </template>
              {{ val1.length }}-{{ $t("choos.month") }}
            </div>
            <div>
              <b>${{ val1.price }}</b>
              <s>${{ val1.del_price }}</s>
            </div>
          </div>
          <!-- style="background-color: #eee; box-shadow: 0 2px 6px #eee" -->
          <div @click="goShoppingCart(val, key)" class="loginButton choosButton">
            {{ $t("choos.buy") }}
          </div>
          <!-- <div
            v-if="isshow == key"
            @click="goShoppingCart(val1.id,val, key)"
            class="loginButton choosButton"
          >
            Buy Now
          </div> -->
        </div>
        <div class="content">
          <div v-for="(val2, key2) in val.ability_list" :key="key2">
            <img v-if="val2.checked" src="@/assets/img/dui.png" />
            <img v-if="!val2.checked" src="@/assets/img/dui2.png" />
            <!-- <div>{{ val2.name }}</div> -->
            <span v-if="val2.checked" style="width: 56%; display: inline-block">{{ val2.name }}</span>
            <span v-else style="width: 56%; display: inline-block; color: #939393">{{ val2.name }}</span>
          </div>
        </div>
        <div class="po_Most" v-if="val.is_tui">{{ $t("choos.most") }}</div>
      </div>
    </div>
    <!-- <paddler ref="paddler" @paySuccess="paySuccess" /> -->
  </div>
</template>

<script>
import { Ability, createOrder, getEquipmentList } from "@/api/user";
// import paddler from './paddler/paddler';
export default {
  name: "HelloWorld",
  inject: ["getheader"],
  // components: {
  // 	paddler,
  // },
  data() {
    return {
      val: {},
      isshow: 0,
      list: [],
      system: 1,
      ida: 0,
      msg: "",
      equList: [],
      isOk: true,
      isDestroyed: false,
    };
  },
  async mounted() {
    this.isDestroyed = false;
    if (this.$route.params.system) {
      this.system = this.$route.params.system;
    }
    this.getlist(this.system);
    let adj = await getEquipmentList();
    if (adj.code === 1) {
      this.equList = adj.data;
    }
    this.paySuccess();
    // this.getheader('add')
    // this.getheader('add')
  },
  beforeDestroy() {
    this.isDestroyed = true;
  },
  methods: {
    async paySuccess() {
      // console.log('this.isDestroyed', this.isDestroyed);
      if (this.isDestroyed) {
        return;
      }
      let adj = await getEquipmentList();
      if (!this.isOk) {
        return;
      }
      // console.log(
      //   'adj.code === 1 && this.equList.length < this.count',
      //   adj.code === 1 && this.equList.length < adj.data.length
      // )
      if (adj.code === 1 && this.equList.length < adj.data.length) {
        this.isOk = false;
        this.$router.push({ name: "Guidance", params: { type: "add" } });
        this.getheader("add");
      } else {
        this.paySuccess();
      }
    },
    getlist(a) {
      this.system = a;
      this.list = [];
      Ability({ type: this.system }).then((adj) => {
        console.log(adj);
        this.list = adj.data;
        // this.ida = adj.data[0].package_prices.at(-1).id
        // this.ida = adj.data[0].package_prices[0].id
        this.ida = adj.data[this.isshow].package_prices.find((item) => {
          // return item.length == 1;
          return item.length === 12;
        }).id;
        this.val = adj.data[this.isshow];
        console.log(this.list, this.isshow, this.ida);
      });
    },
    optionOk(ida, val, key) {
      console.log(this.ida, this.val, key);
      console.log(ida, val, key);

      this.ida = ida;
      this.val = val;
      if (this.isshow !== key) {
        this.isshow = key;
      }
    },
    oks(val, key) {
      console.log(this.ida, val, key);
      this.val = val;
      if (this.isshow !== key) {
        this.isshow = key;
        if (val.name === "Premium") {
          this.ida = val.package_prices.find((item) => {
            return item.length == 1;
          }).id;
        } else {
          this.ida = val.package_prices[0].id;
        }
        // this.ida = val.package_prices.at(-1).id
      } else {
      }
    },
    goShoppingCart(val, index) {
      if (this.isshow !== index) {
        this.isshow = index;
        this.val = val;
        if (val.name === "Premium") {
          this.ida = val.package_prices.find((item) => {
            return item.length === 12;
          }).id;
        } else {
          this.ida = val.package_prices[0].id;
        }
      }
      if (!this.ida) {
        return false;
      }

      let temp = this.list[this.isshow].package_prices.find(
        (item) => Number(item.id) === Number(this.ida)
      );
      let key = {
        name: this.val.name,
        order_price: temp.del_price,
        pay_price: temp.price,
        package_price_id: temp.id,
        type: this.system === 1 ? 1 : 2,
        pay_type: ["fr", "en", "br", "es", "ar", "de", "it"].includes(this.$i18n.locale) ? 6 : 4,
      };
      createOrder(key).then(({ code, data, msg }) => {
        if (code !== 1) {
          this.$message(msg);
          return false;
        }

        let order_sn = data.order_sn;
        let url = `${this.payHref[this.$i18n.locale]}?order_sn=` + order_sn;
        if (["fr", "en", "br", "es", "ar", "de", "it"].includes(this.$i18n.locale)) {
          const token = localStorage.getItem("token");

          if (this.$i18n.locale === "en") {
            url =
              `https://www.spylix.com/checkout.html?order_sn=` +
              order_sn +
              "&token=" +
              token;
          } else {
            url =
              `https://www.spylix.com/${this.$i18n.locale}/checkout.html?order_sn=` +
              order_sn +
              "&token=" +
              token;
          }
        }

        window.location.href = url;
        // let url = "https://pay.lookasoft.com/api/stripe_pay_url?order_sn="+order_sn
        // window.open('javascript:window.name;','<script>location.replace("'+url+'")<\/script>');
        // pay_type为3时，url为store.lookasoft.com：
        // let url = "https://store.lookasoft.com/api/paddle_pay_url?order_sn="+order_sn
        // pay_type为4时，url为store.lookasoft.com：

        // this.$refs.paddler.showEdit(data.id, temp.paddle_product_id);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Popup.syy .Popups {
  width: 400px;
  height: 320px;
  margin: -160px 0 0 -200px;
}

.syy .syy_title {
  margin-top: 30px;
  line-height: 30px;
  font-size: 16px;
  text-align: center;
}

.syy .syy_ftitle {
  font-size: 14px;
  color: #45484d;
  width: 100%;
  text-align: center;
  height: 30px;
  margin: 20px 0 30px;
}

.syy .syy_ftitle span {
  font-size: 24px;
  font-weight: 700;
  color: #000927;
}

.syy .syy_ftitle s {
  color: #45484d;
}

.syy .loginButton {
  width: 264px;
  font-size: 15px;
  color: #000927;
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
}

.syy .imgButton {
  width: 262px;
  height: 38px;
  overflow: hidden;
  font-size: 15px;
  color: #000927;
  border: 1px solid #d5d7db;
  border-radius: 22px;
  margin: 0 auto;
}

.syy .imgButton img {
  display: block;
  height: 24px;
  margin: 6px auto;
}

.syy .inputButton {
  width: 262px;
  height: 38px;
  overflow: hidden;
  font-size: 15px;
  color: #000927;
  border: 1px solid #d5d7db;
  border-radius: 22px;
  margin: 20px auto;
  background: #f6f8fa;
}

.syy .inputButton img {
  float: left;
  width: 24px;
  height: 24px;
  margin: 7px 5px 0 13px;
}

.syy .inputButton input {
  float: left;
  border: none;
  padding: 0;
  line-height: 38px;
  height: 38px;
  background: none;
}

.syy .inputButton img.dow {
  width: 16px;
  height: 16px;
  float: right;
  margin: 11px 17px 0 0;
}

.syy a {
  font-size: 13px;
  color: #0080ff;
  text-align: center;
  line-height: 24px;
  display: block;
  margin: 0 auto;
}

.header {
  position: fixed;
  height: 60px;
  z-index: 99;
  background: #000927;
  width: 100%;
  top: 0;
}

.header .logo {
  float: left;
  height: 20px;
  margin: 20px;
}

.header .language {
  float: right;
  margin: 20px;
  height: 20px;
  overflow: hidden;
}

.header .language .flag {
  border-radius: 8px;
}

.header .language .dow,
.header .language .flag {
  width: 16px;
  height: 16px;
  overflow: hidden;
  float: left;
  position: relative;
  margin: 2px;
}

.header .language img {
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  left: 0;
}

.header .user {
  float: right;
  margin: 18px 35px 0 0;
  height: 24px;
  width: 24px;
  overflow: hidden;
}

.header .user img {
  float: left;
  height: 24px;
  width: 24px;
}

#Choos {
  padding-top: 0;
}

#Choos .title {
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
}

#Choos .system {
  height: 38px;
  width: 202px;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  line-height: 36px;
}

#Choos .system div {
  min-width: 126px;
  width: auto;
  float: left;
  line-height: 36px;
  border: 1px solid #d5d7db;
  border-left: none;
  border-radius: 0 8px 8px 0;
  background: #fff;
  cursor: pointer;
}

#Choos .system div:first-child {
  border-left: 1px solid #d5d7db;
  border-right: none;
  border-radius: 8px 0 0 8px;
}

#Choos .system div.mr {
  border-color: #00eec3;
  background: #00eec3;
}

#Choos .system div img {
  display: inline;
  width: 16px;
  height: 16px;
  margin: 0 6px -2px 0;
}

.system_ul {
  margin: 40px auto 0;
  width: 1110px;
  overflow: hidden;
  padding-bottom: 70px;
}

.system_li {
  float: left;
  width: 336px;
  margin: 30px 0 20px 25px;
  background: #fff;
  border-radius: 12px;
  position: relative;
}

.system_li.mr {
  width: 360px;
  margin: 0 0 0 25px;
  padding: 30px 0 20px;
  border: 1px solid #00eec3;
  -webkit-box-shadow: 0 4px 16px -4px rgba(122, 138, 153, 0.4);
  box-shadow: 0 4px 16px -4px rgba(122, 138, 153, 0.4);
}

.system_li .top {
  height: 46px;
  width: 100%;
  overflow: hidden;
  padding: 25px 0;
}

.top_left {
  float: left;
  text-indent: 25px;
}

.top_l_t {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 1px;
}

.top_l_b {
  font-size: 13px;
  color: #808080;
}

.top_right {
  float: right;
  line-height: 46px;
  align-items: center;
  /* font-size: 32px; */
  font-size: 22px;
  margin-right: 15px;
  display: flex;
}

.top_right div {
  font-size: 15px;
  display: flex;
  color: #9f9f9f;
  align-items: center;
}

.top_right s {
  font-size: 15px;
  color: #9f9f9f;
  line-height: 50px;
}

.option {
  border-top: 1px solid #e1e3e6;
  border-bottom: 1px solid #e1e3e6;
}

.option_o {
  font-size: 14px;
  line-height: 20px;
  margin-top: 20px;
}

.option_o s {
  color: #9f9f9f;
}

.option_o img {
  width: 20px;
  height: 20px;
  float: left;
  margin-left: 40px;
  margin-right: 10px;
}

.choosButton {
  width: 270px;
  height: 40px;
  line-height: 40px;
  margin-top: 30px;
  margin-bottom: 30px;
  font-size: 15px;
}

.content {
  overflow: hidden;
  padding: 10px 0 30px;
  color: #45484d;
}

.content div {
  width: 50%;
  float: left;
  margin-top: 14px;
  line-height: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.content div div {
  margin-top: 0;
}

.content div img {
  width: 16px;
  float: left;
  margin: 0 4px 0 16px;
}

.po_Most {
  /* display: none; */
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 12px;
  height: 26px;
  line-height: 26px;
  background: rgba(0, 238, 195, 0.2);
  border-radius: 0 9px 0 12px;
  font-size: 12px;
  color: #00d6b0;
  font-weight: 400;
}

.system_li.mr .po_Most {
  display: block;
}

.system_logo {
  display: inline-block;
  font-size: 20px;
}

.system_li.mr .top_right {
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChoosCopyTest.vue